// extracted by mini-css-extract-plugin
export var columnList = "_bl-0";